import {Component} from '@angular/core';
import { CalendarOptions } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import itLocale from '@fullcalendar/core/locales/it';

@Component({
    selector: 'my-calendar',
    template: `
    <div class="cal-cnt">
    <full-calendar [deepChangeDetection]="false" [options]="calendarOptions" id="calendar{{calIndex}}">
    </full-calendar>
    </div>
    `
})
export class MyCalendarComponent {

  calIndex = 0;

  calendarOptions: CalendarOptions = {
    droppable: false,
    initialView: 'month',
    initialDate: new Date(),
    firstDay: 3,
    selectAllow: () => false,
    plugins: [dayGridPlugin,],
    views: {
        month: {
            dayMaxEvents: false,
            type: 'dayGridMonth',
            displayEventEnd: true,
        }
    },
    locales: [itLocale],
    eventTimeFormat: {
        hour: '2-digit',
        minute: '2-digit',
        meridiem: false
    },
    headerToolbar: {
        left: 'title',
        center: '',
        right: 'prev,next'
    },
    eventColor: '#3a87ad',
    eventTextColor: '#ffffff',
    weekends: true,
    // eventDragStop: (arg) => this.onCalendarEventDragStop(arg),
    // drop: (arg) => this.onCalendarDrop(arg),
    // dateClick: (arg) => this.onCalendarDateClick(arg),
    // eventDrop: (arg) => this.onCalendarEventDrop(arg),
    // eventResize: (arg) => this.onCalendarEventResize(arg),
    // select: (arg) => this.onCalendarDateSelected(arg),
    // eventClick: (arg) => this.onCalendarEventClick(arg),
    // eventDidMount: (arg) => this.onCalendarEventMount(arg),
    // datesSet: (arg) => this.onCalendarDatesSet(arg),
    
};

  // private loadData(startDate: string, endDate: string){

    // this._api.getCalendarNews(startDate, endDate).subscribe(res=>{
    //   this.calendarOptions.events = [];
    //   this.calendarOptions.events = res.map(n=> ({ title: n.message, start: n.date.toISOString().substring(0,10) }) );
    // });
  // }

	ngOnInit() {

    do{
      this.calIndex = Math.floor(Math.random()*100);
    }while(document.getElementById('calendar'+ this.calIndex));
  }

  // onCalendarEventClick(arg: EventClickArg) {
    // this._dialog.infoAlert('Dettaglio evento',arg.event.title + "<br/><br/>" + this._dateParser.formatDateToItalian(arg.event.start) );
  // }

  // onCalendarDatesSet(arg: DatesSetArg) {
  //   this.loadData(arg.view.activeStart.toISOString(), arg.view.activeEnd.toISOString());
  // }
}
